<template>
  <div v-if="labels">
    <h3 class="ds-heading md-heading ds-margin-bottom-48">
      {{ filterLabels.integrateSectionTitle }}
    </h3>
    <div class="ds-grid">
      <DsCardTextIcon
        class="ds-grid__col ds-grid__col--12 ds-md-grid__col--6 wds-md-grid__col--no-gutter-left ds-margin-bottom-24"
        :icon="{ category: 'ui-and-people', name: 'user-heart' }"
        :title="filterLabels.integrateExistingCustomerTitle"
        :text="filterLabels.integrateExistingCustomerDescription"
        :link="integrateExistingCustomerLink"
      />
      <DsCardTextIcon
        class="ds-grid__col ds-grid__col--12 ds-md-grid__col--6 wds-md-grid__col--no-gutter-right"
        :icon="{ category: 'hands', name: 'hands-love' }"
        :title="filterLabels.integrateNotACustomerTitle"
        :text="filterLabels.integrateNotACustomerDescription"
        :link="integrateNotACustomerLink"
      />
    </div>
  </div>
</template>
<script setup>
import { DsCardTextIcon } from 'awds'
import { mapperModuleNavigationLink } from '../../../core/data-layer/modules/mappers'

const { labels } = useGlobalData()
const { locale: localeRef } = useI18n()
const store = useRoutesStore()

const filterLabels = computed(() => {
  return labels.value
})

const integrateExistingCustomerLink = computed(() => {
  const { getUrl } = useRoutes(store.routes, localeRef)

  return filterLabels.value.integrateExistingCustomerLink
    ? mapperModuleNavigationLink(filterLabels.value.integrateExistingCustomerLink, getUrl)
    : null
})

const integrateNotACustomerLink = computed(() => {
  const { getUrl } = useRoutes(store.routes, localeRef)

  return filterLabels.value.integrateNotACustomerLink
    ? mapperModuleNavigationLink(filterLabels.value.integrateNotACustomerLink, getUrl)
    : null
})

</script>
<script>

export default {
  name: 'PaymentMethodIntegrate'
}
</script>
